<template>
	<div>
		<edu-login-button v-if="showEduLogin" @terms-not-accepted="handleTermsNotAccepted" />			
		<google-button @terms-not-accepted="handleTermsNotAccepted" />
		<v-form ref="form" v-model="valid" method="POST" action="/login" class="mt-5" @submit.prevent="onSubmit">
			<input type="hidden" name="_token" :value="csrf">
			<base-label :label="$t('email')" forLabel="email" />
			<v-text-field id="email" class="mt-1 input-rounded" v-model="form.email" dense outlined required
										type="email" :rules="[rules.required, rules.email]" name="email" ref="emailInput"
										:placeholder="$t('enterEmail')" />
			<base-label :label="$t('password')" forLabel="password" />
			<v-text-field id="password" class="mt-1 base-input-1 input-rounded" v-model="form.password" hide-details outlined
										dense required
										type="password" :rules="[rules.required]" name="password" ref="passwordInput"
										:placeholder="$t('enterPassword')" />
			<terms-agreement-checkbox 
				ref="termsCheckbox"
				:require-validation="true"
				@terms-changed="onTermsChanged"
			/>
			<v-row justify="space-between" align="baseline" no-gutters class="mt-1">
				<div>
					<v-checkbox :label="$t('loginPage.rememberMe')" name="remember" color="textColor" hide-details
											class="custom-checkbox" />
				</div>
				<div class="px-1 forgot-password"><a @click="gotoForgotPassword">
					{{ $t('loginPage.forgotPasswordButton') }}
				</a></div>
			</v-row>

			<v-row justify="center" v-if="error">
				<v-col cols="12">
					<v-alert type="error">
						<span class="text-h3">{{ error }}</span>
					</v-alert>
				</v-col>
			</v-row>

			<v-row justify="center" class="px-1">
				<v-col>
					<v-btn block type="submit" color="btnColor" rounded :loading="loading">
						<div class="">
								<span class="pa-2">
									<v-progress-circular v-if="loading" indeterminate :size="30" :width="4"
																			 color="white"></v-progress-circular></span>
							<span class="px-2 font-weight-bold text-h5">{{ $t("login") }}</span>
						</div>
					</v-btn>
				</v-col>
			</v-row>


		</v-form>
		<v-row justify="center" class="pt-4 mt-4 text-decoration-underline font-weight-bold">
			<a @click="$emit('register')">
				{{ $t('loginPage.registerButton') }}
			</a>
		</v-row>
	</div>
</template>

<script>
import rules from "@/helpers/rules";
import GoogleButton from "@/components/GoogleButton";
import BaseLabel from "@/components/BaseLabel";
import EduLoginButton from "@/components/EduLoginButton";
import TermsAgreementCheckbox from "@/components/TermsAgreementCheckbox";
export default {
	name: "LoginForm",
	components: { GoogleButton, BaseLabel , EduLoginButton, TermsAgreementCheckbox},
	props: {
		loading: Boolean,
		error: String,
		showEduLogin: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		form: {
			email: "",
			password: "",
		},
		rules,
		valid: false,
	}),
	computed: {
		csrf() {
			const token = document.querySelector("meta[name=csrf-token]");
			return token ? token.getAttribute("content") : "";
		},
	},
	mounted() {
		// Terms logic is now handled by TermsAgreementCheckbox component
	},
	methods: {
		handleTermsNotAccepted() {
			if (this.$refs.termsCheckbox) {
				this.$refs.termsCheckbox.handleTermsNotAccepted();
			}
		},
		onTermsChanged(termsAccepted) {
			// Handle terms change if needed
		},
		async onSubmit(event) {
			if (!this.$refs.emailInput.validate() || !this.$refs.passwordInput.validate()) {
				return;
			}
			this.$emit("submit", { form: this.form, event });
		},
		gotoForgotPassword() {
			this.$router.push({ path: "forgot-password" });
		}
	}
}
</script>

<style scoped>
.v-input--selection-controls {
	margin-top: 0 !important;
}

.custom-checkbox {

.v-label {
	color: var(--v-textColor-base);
}

.v-icon {
	font-size: 20px !important;
}

}
.forgot-password {
	font-size: 14px;
	color: #0068F5;
	text-decoration: underline;
}
</style>
